import { useSetting } from "@faire/retailer-visitor-shared/settings/__internal__/useSetting";
export function useBooleanSetting(setting) {
    return useSetting(setting, false);
}
